import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import TypesService from "../../api/types";


export const getEventTypes = createAsyncThunk(
    "eventtypes/get",
    async (args, thunkAPI) => {
      try {
        const response = await TypesService.getEventTypes(args);
        //thunkAPI.dispatch(setMessage(response.data.message));
        return response;
      } catch (error) {
          console.log("Error: ", error)
          const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        //thunkAPI.dispatch(setMessage(message));
        return thunkAPI.rejectWithValue();
      }
    }
  );
  

  const initialState = {
    fetching: false,
    events: [],
};


const typesSlice = createSlice({
    name: "types",
    initialState,
    extraReducers: {
      [getEventTypes.pending]: (state, action) => {
          state.fetching = true;
      },
      [getEventTypes.fulfilled]: (state, action) => {
          state.fetching = false;
          state.events = action.payload;
      },
      [getEventTypes.rejected]: (state, action) => {
          state.error = "Ekki tókst að sækja flokka";
      },
    },
  });
  

const { reducer } = typesSlice;
export default reducer;